import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { LocationsRouterStoreSelectors } from '../router';

import { ResolveFn } from '@angular/router';
import { forkJoin } from 'rxjs';
import { filter, first, map, switchMap, tap } from 'rxjs/operators';
import { AppSettingsStoreActions, AppSettingsStoreSelectors } from '../app-settings';

import { getAncestors } from '../router/category';
import { selectCurrentCategoryFromRouter } from '../router/router.selector';

export const applicationSettingsResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);

  return store.select(selectCurrentCategoryFromRouter).pipe(
    filter((category) => !!category),
    switchMap((category) =>
      store.select(LocationsRouterStoreSelectors.selectBundleId).pipe(
        first(),
        switchMap((bundleId) => {
          const safeBundleId = bundleId ?? '';
          const ancestors = getAncestors(category);
          const checks = ancestors.map((anc) =>
            store.select(AppSettingsStoreSelectors.selectSettingsForCurrent(safeBundleId, anc)).pipe(
              first(),
              tap((settings) => {
                if (!settings || settings.length === 0) {
                  store.dispatch(
                    AppSettingsStoreActions.AppSettingsResolverActions.appSettingsRequested({
                      bundleIdentifier: safeBundleId,
                      categoryType: anc.categoryType,
                      categoryId: anc.categoryId,
                    })
                  );
                }
              })
            )
          );

          return forkJoin(checks).pipe(map(() => true));
        })
      )
    ),
    first()
  );
};
